import { render } from "./CreateFlow.vue?vue&type=template&id=3847771f&scoped=true"
import script from "./CreateFlow.vue?vue&type=script&lang=js"
export * from "./CreateFlow.vue?vue&type=script&lang=js"

import "./CreateFlow.vue?vue&type=style&index=0&id=3847771f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3847771f"]])

export default __exports__